export enum Survey {
  TherapyIntakeBeforeYouGo = 'cic-therapy-intake-before-you-go',
}
